import stickElement from '../util/stickit'
import 'jquery-match-height'
import '@fancyapps/fancybox'

function smooth_scroll(link, e) {
  if (e) e.preventDefault()
  var hash = false
  if (!link && window.location.hash) {
    hash = window.location.hash
  } else if (link && link.indexOf('#') == 0) {
    hash = link
  } else if (link) {
    if (typeof link !== 'string') {
      if (
        location.pathname.replace(/^\//, '') ==
          link.pathname.replace(/^\//, '') &&
        location.hostname == link.hostname
      ) {
        hash = link.hash
      }
    } else {
      let index = link.indexOf('#')
      let substr = link.substr(index)
      hash = substr
    }
  }

  if (hash) {
    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top - 110,
      },
      600
    )
    history.replaceState(null, null, hash)
  }
  $(window).trigger('hashchange')
}

function getScrollWindow() {
  var e = document.documentElement,
    o = document.body,
    t = e.scrollTop || (o && o.scrollTop) || 0
  return (t -= e.clientTop)
}

function resizeFullWidthRow() {
  $('[data-vc-full-width="true"]').each(function () {
    $(this).css({
      width: document.body.clientWidth,
      marginLeft: -document.body.clientWidth / 2,
    })
    if (!$(this).attr('data-vc-stretch-content')) {
      // let padding =
      //   (document.body.clientWidth - $('.container.wrap').outerWidth()) / 2
      // $(this).css({
      //   'padding-left': padding,
      //   'padding-right': padding,
      // })
    }
  })
}

const headerMenuInit = () => {
  const headerMenu = $('.js-header-menu')
  const headerMenuOffset = headerMenu.offset().left + headerMenu.outerWidth()

  $('.dropdown-menu', headerMenu).each(function () {
    const dropdownMenu = $(this)
    dropdownMenu.addClass('get-position')
    const dropdownMenuOffset =
      dropdownMenu.offset().left + dropdownMenu.outerWidth()

    if (dropdownMenu.hasClass('level-0')) {
      if (dropdownMenuOffset > headerMenuOffset) {
        dropdownMenu.addClass('dropdown-menu-right').css({
          right: 0,
          left: 'auto',
        })
      }
    } else {
      if (dropdownMenuOffset > headerMenuOffset) {
        dropdownMenu.addClass('dropleft').css({
          right: '100%',
          left: 'auto',
        })
      }
    }

    setTimeout(function () {
      dropdownMenu.removeClass('get-position')
    }, 500)
  })

  $('.dropdown', headerMenu).hover(
    function () {
      $(this)
        .addClass('open')
        .children('.dropdown-menu')
        .stop(true, true)
        .fadeIn(300)
    },
    function () {
      $(this)
        .removeClass('open')
        .children('.dropdown-menu')
        .stop(true, true)
        .fadeOut(200)
    }
  )
}

const mobileMenuInit = () => {
  $('#mobile-navigation').on('click', '.js-dropdown-toggle', function () {
    const menuItem = $(this).closest('.menu-item')
    const dropDownMenuOpened = menuItem.closest('ul').find('.menu-item.show')

    if (!menuItem.hasClass('show')) {
      dropDownMenuOpened
        .removeClass('show')
        .find('.mobile-dropdown')
        .stop()
        .slideUp(200)
    }

    menuItem
      .toggleClass('show')
      .children('.mobile-dropdown')
      .stop()
      .slideToggle(300)
  })

  const viewport = window.bootstrapToolkit
  const navToggler = $('.js-navbar-toggler')
  $(window).resize(
    viewport.changed(function () {
      if (viewport.is('>md') && !navToggler.hasClass('collapsed')) {
        navToggler.trigger('click')
      }
    })
  )
}

const bannerInit = () => {
  $(document).ready(function () {
    if ($(window).width() > 768) {
      $('.js-left-banner').removeClass('d-none')
    }
    if ($(window).width() < 768) {
      if (window.localStorage.getItem('closedLeftBanner')) {
        $('.js-left-banner').addClass('d-none')
      } else {
        $('.js-left-banner').removeClass('d-none')
      }
    }
    $('.js-banner-left__toggler').on('click', function () {
      if ($(window).width() < 768) {
        $(this).closest('.banner').toggleClass('closed').slideToggle()

        window.localStorage.setItem('closedLeftBanner', true)
      } else {
        const $banner = $(this).closest('.banner')
        if (
          !$banner.hasClass('closed') &&
          !window.localStorage.getItem('closedLeftBanner')
        ) {
          window.localStorage.setItem('closedLeftBanner', true)
        }
        $banner.toggleClass('closed').toggleClass('opened')
        $('.closed_icon_megaphone').toggleClass('opened')
      }
    })

    if ($(window).width() >= 768) {
      setTimeout(() => {
        $('.js-left-banner.left-banner-1').removeClass('hidden')
        $('.js-left-banner.left-banner-1').addClass('closed')
      }, 5000)

      setTimeout(() => {
        $('.js-left-banner.left-banner-2').removeClass('hidden')
        $('.js-left-banner.left-banner-2').addClass('closed')
      }, 7000)
    } else {
      $('.js-left-banner.left-banner-1').hide()
      $('.js-left-banner.left-banner-1').removeClass('hidden')
      $('.js-left-banner.left-banner-1').removeClass('d-none')
      $('.js-left-banner.left-banner-1').addClass('closed')
      $('.js-left-banner.left-banner-2').hide()
      $('.js-left-banner.left-banner-2').removeClass('hidden')
      $('.js-left-banner.left-banner-2').removeClass('d-none')
      $('.js-left-banner.left-banner-2').addClass('closed')
      setTimeout(() => {
        $('.js-left-banner-icon').addClass('animation')
      }, 1000)

      setTimeout(() => {
        $('.js-left-banner-icon').removeClass('animation')
      }, 16000)
    }

    $('.js-banner-right__toggler').on('click', function () {
      const $banner = $(this).closest('.banner')
      if (
        !$banner.hasClass('closed') &&
        !window.localStorage.getItem('closedRightBanner')
      ) {
        window.localStorage.setItem('closedRightBanner', true)
      }
      if ($(window).width() >= 768) {
        $banner.toggleClass('closed').toggleClass('opened')
      } else {
        $banner.toggleClass('closed').toggleClass('opened').slideToggle()
      }
    })

    $('.js-banner-right__toggler-right').on('click', function () {
      const $banner = $(this).closest('.banner')

      if ($(window).width() >= 768) {
        $banner.addClass('smallest')
      }
    })

    $('.js-banner-right__toggler-smallest').on('click', function () {
      const $banner = $(this).closest('.right-banner-smallest').next('.banner')

      if ($(window).width() >= 768) {
        $banner
          .removeClass('smallest')
          .toggleClass('closed')
          .toggleClass('opened')
      }
    })

    $('.js-weather-api').on('click', function () {
      $('.left-banner').removeClass('closed').slideUp()
      $('.right-banner').toggleClass('closed').slideToggle()
    })

    var popUpButton = document.querySelector('.pop-up-side-button')
    var popUpContent = document.querySelector('.pop-up-content')
    var closeButton = document.querySelector('.close-button')

    if (popUpButton) {
      popUpButton.addEventListener('click', function (e) {
        e.preventDefault()
        popUpContent.style.display = 'block'
        popUpButton.style.display = 'none'
      })
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        popUpContent.style.display = 'none'
        popUpButton.style.display = 'block'
      })
    }

    window.addEventListener('click', function (e) {
      if (e.target === popUpContent) {
        popUpContent.style.display = 'none'
        popUpButton.style.display = 'block'
      }
    })

    /*
    const rightBanner = $('.js-right-banner')
    let bannerTimeout
    const timerStart = () => {
      const hiddenTime = rightBanner.data('hide-time')
      bannerTimeout = setTimeout(function() {
        rightBanner.addClass('closed')
        // window.localStorage.setItem('closedRightBanner', true)
      }, parseInt(hiddenTime * 1000))
    }

    if (!window.localStorage.getItem('closedRightBanner')) {
      rightBanner.removeClass('closed')

      timerStart()

      rightBanner.hover(
        function() {
          clearTimeout(bannerTimeout)
        },
        function() {
          if (!rightBanner.hasClass('opened')) {
            timerStart()
          }
        }
      )
    } else {
      rightBanner.addClass('closed')
    }
    */

    $('.modal').on('click', '.js-coupon-btn', function () {
      const couponInput = $(this).data('value')
      const couponInputWrapper = $(this).closest('.coupon-btn__wrapper')
      var $temp = $('<input>')
      couponInputWrapper.append($temp)
      $temp.val(couponInput).focus().select()
      document.execCommand('copy')
      $temp.remove()
      couponInputWrapper.find('.sucsess-text').fadeIn()

      setTimeout(function () {
        couponInputWrapper.find('.sucsess-text').fadeOut(500)
      }, 3000)
    })
    // Open share links in new window
    $('.share-button').click(function (e) {
      e.preventDefault()
      var wpWidth = $(window).width()
      var wpHeight = $(window).height()
      window.open(
        $(this).attr('href'),
        'Share',
        'top=' +
          (wpHeight - 400) / 2 +
          ',left=' +
          (wpWidth - 600) / 2 +
          ',width=600,height=400'
      )
    })
  })

  $('.js-left-banner-icon').on('click', function (e) {
    e.preventDefault()
    $('.right-banner').removeClass('closed').slideUp()
    $('.left-banner').toggleClass('closed').slideToggle()
  })

  const $leftBaner = $('.js-left-banner')

  if (!window.localStorage.getItem('closedLeftBanner')) {
    $leftBaner.removeClass('closed')

    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 0 && !$leftBaner.hasClass('closed')) {
        $leftBaner.addClass('closed')
      }
    })
  }

  if (
    $(window).width() < 768 &&
    !window.localStorage.getItem('closedLeftBanner')
  ) {
    $leftBaner.removeClass('closed')
  }
}

const snowfallInit = () => {
  $(window).on('scroll', function () {
    if ($('.pop-up-side-button-container').length === 0) {
      $('.dhsv-snowfall button.visible').css({ bottom: '115px' })
    }
  })
}

/*const snowfallInit = () => {
  if (!document.querySelector('.pop-up-side-button-container')) {
    const visibleButtons = document.querySelectorAll(
      '.dhsv-snowfall button.visible'
    )
    visibleButtons.forEach(button => {
      button.style.bottom = '115px'
      observer.disconnect()
    })
  }
  console.log('foo')
}

const observer = new MutationObserver(snowfallInit)

const observerConfig = { subtree: true, childList: true }

observer.observe(document.documentElement, observerConfig)*/

const popUpInit = () => {
  $(document).ready(function () {
    if (!window.localStorage.getItem('closedPopUp')) {
      $('.popup__wrapper').removeClass('closed').slideDown()
    }

    $('.toggler-btn-popup').on('click', function () {
      if (!window.localStorage.getItem('closedPopUp')) {
        window.localStorage.setItem('closedPopUp', true)
        $(this).parent().parent().addClass('closed').slideUp()
      }
    })
  })
}

// Remove placeholder
const removePlaceholder = () => {
  $('.gfield_consent_label').each(function () {
    if ($(this).next('.gfield_required').length) {
      $(this).next('.gfield_required').appendTo($(this))
    }
  })

  $('.gform_wrapper input, .gform_wrapper textarea').each(function () {
    $(this).data('holder', $(this).attr('placeholder'))

    $(this).focusin(function () {
      $(this).attr('placeholder', '')
    })

    $(this).focusout(function () {
      $(this).attr('placeholder', $(this).data('holder'))
    })
  })

  $(
    '.gform_wrapper input, .gform_wrapper textarea, .gform_wrapper select'
  ).each(function () {
    $(this).focusin(function () {
      $(this).closest('.gfield').addClass('active')
    })

    $(this).focusout(function () {
      $(this).closest('.gfield').removeClass('active')
    })
  })
}

function sitemap_scroll() {
  $('.site-map__link').on('click tap', function () {
    //$('html, body').animate({ scrollTop: $(document).height() }, 'slow')

    $('.site-map__link').addClass('open')

    if ($('.site-map__link').hasClass('open')) {
      $('html, body').animate(
        {
          scrollTop: $('#siteMapMenuAnchor').offset().top,
        },
        1000
      )
    } else {
      $('.site-map__link').removeClass('open')
      $('html, body').animate(
        {
          scrollTop: $('.site-map').offset().top,
        },
        1500
      )
    }
  })
}

function hyphenationInit() {
  var lang_code = $('html')[0].lang.split('-')
  if (lang_code[0] == 'en') {
    $('h3.post-item__title').hyphenate('en-us')
  }
  if (lang_code[0] == 'de') {
    $('h3.post-item__title').hyphenate('de')
  }
}

// decode ROT13 encrypted mail address
function emailDecode(a) {
  return a.replace(/[a-zA-Z]/g, function (c) {
    return String.fromCharCode(
      (c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26
    )
  })
}

export default {
  init() {
    // example: <a class="openmailer" href="#" data-mail="orahgmre@qbznva.qr" data-subject="Lorem%20ipsum">Email schreiben</a>
    $('a.openmailer').on('click', function (e) {
      e.preventDefault()

      // Decode email address
      var emaildecode = emailDecode($(this).attr('data-mail'))

      // Check if data-subject is available and append it to the mailto link
      var subject = $(this).attr('data-subject')
      var mailtoLink = 'mailto:' + emaildecode
      if (subject) {
        mailtoLink += '?subject=' + encodeURIComponent(subject)
      }

      window.location.href = mailtoLink
    })

    $('.fancybox, .prettyphoto').fancybox({
      touch: false,
      minHeight: 0,
      helpers: {
        overlay: {
          locked: false,
        },
      },
    })

    sitemap_scroll()

    headerMenuInit()

    mobileMenuInit()

    bannerInit()

    snowfallInit()

    popUpInit()

    hyphenationInit()

    $(window).load(function () {
      /* eslint-disable */
      $(
        'a[href^="#"]:not([href="#"],[href="#0"],[href^="#fancy-"],[data-toggle],[role="tab"],[data-vc-tabs], [data-vc-accordion])'
      ).on('click', function (e) {
        smooth_scroll($(this).attr('href'), e)
      })
      /* eslint-enable */
      if (window.location.hash) {
        smooth_scroll(window.location.hash)
      }
    })

    removePlaceholder()

    $(document).bind('gform_post_render', function () {
      removePlaceholder()
    })

    // set sticky header classes
    if ($(window).width() >= 768) {
      $('.navbar__wrapper').addClass('js-sticky-banner')
    } else {
      $('header.banner').addClass('js-sticky-banner')
    }

    // Scroll to top
    // defining elements

    var $toTop = $('.js-to-top')

    $(document).ready(function () {
      // Listening for click event
      $toTop.on('click', function (e) {
        e.preventDefault()
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          600
        )
      })

      // Scroll through button
      $('body').on('click', '.js-scroll-through', function (e) {
        e.preventDefault()
        let $section = $(this).closest('.vc_section')

        $('html, body').animate(
          {
            scrollTop:
              $section.offset().top +
              $section.outerHeight() -
              $('.js-sticky-banner').outerHeight() +
              1,
          },
          600
        )
      })
    })

    $(window).on('scroll', function () {
      // Detecting when to show the button
      if (
        getScrollWindow() > $(window).outerHeight() / 2 &&
        !$toTop.hasClass('visible')
      ) {
        $toTop.addClass('visible')
      } else if (
        getScrollWindow() <= $(window).outerHeight() / 2 &&
        $toTop.hasClass('visible')
      ) {
        $toTop.removeClass('visible')
      }
    })

    resizeFullWidthRow()

    $(window).on('resize', function () {
      resizeFullWidthRow()
    })
  },
  finalize() {
    stickElement('.js-sticky-banner')
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
